import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { OptionalTasksTab } from '../tabs/OptionalTasksTab';
export function OptionalTasksPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(OptionalTasksTab, {
            programId: programId
        })
    });
}
